module.exports = __webpack_public_path__ + "img/plantdetail.8e9f1da2.svg";